import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import Plaid from './Plaid';
import Finicity from './Finicity';
import Yodlee from './Yodlee';

const AggregatorButtonPicker = ({ resource, ...rest }) => {
  return pickFunction(resource, {
    [fr.relationships.finicityLink.name]: () => {
      return (
        <Finicity
          resource={resource}
          {...rest}
        />
      );
    },
    [fr.relationships.yodleeLink.name]: () => {
      return (
        <Yodlee
          resource={resource}
          {...rest}
        />
      );
    },
    [fr.relationships.plaidLink.name]: () => {
      return (
        <Plaid
          resource={resource}
          {...rest}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      throw new Error('Developer error: Aggregator relationship expected. Should have been checked earlier.');
    },
  });
};

export default AggregatorButtonPicker;
